export default __webpack_public_path__ + "assets/webgl/scene-15.1004a427.glb";